// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table thead.v-data-table-header th,table thead.v-data-table th{font-size:15px!important;padding:13px!important;text-align:right!important}#list-item-294-5 .v-list-item__content .v-list-item__title{display:none}#list-item-294-5 .v-list-item__content:after{content:\"همه\"}", ""]);
// Exports
module.exports = exports;
